<div class="row mt-md-2">
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version.name" label="Name"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version.sitz" label="Sitz"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [value]="version.rechtsform?.text | translateName"
      label="Rechtsform"></cap-kopfdatenelement>
  </div>
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version.art | translate" label="Art"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [metaData]="master?.mEgbpid"
      [value]="master?.egbpid"
      label="EGBPID"></cap-kopfdatenelement>
    <cap-kopfdatenelement label="ErstelltMit">
      <cap-kompakt-timepoint [item]="version?.histInfo.vonTimePoint"></cap-kompakt-timepoint>
    </cap-kopfdatenelement>
    <cap-kopfdatenelement label="GestrichenMit">
      <cap-kompakt-timepoint [item]="version?.histInfo.bisTimePoint"></cap-kompakt-timepoint>
    </cap-kopfdatenelement>
  </div>
</div>
